import { action } from 'satcheljs';

/**
 * This action will get dispatched when privacy and terms option is loaded
 */
const loadPrivacyAndTermsOption = action('loadPrivacyAndTermsOption');

export default loadPrivacyAndTermsOption;
